export default "__VITE_ASSET__DR24xN3q__"